import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';

export const ORDER_HISTORY_FLOW_NAME = 'card_ordering_history';

const debugConfig = createDebugConfig();

// Both order history filters report the same event and are told apart by element_name.
const trackSearchOrder = (elementName: string) => {
    trackCustomEvent(
        'search_order',
        {
            trigger: 'click',
            flow_name: ORDER_HISTORY_FLOW_NAME,
            element_name: elementName,
        },
        debugConfig
    );
};

export const trackOrderHistorySearch = () => trackSearchOrder('search_bar');

export const trackOrderHistoryStatusFilter = () => trackSearchOrder('status_filter');
